import React from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "./style.css";
const DropDown = (props) => {
  return (
    <div>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
        <InputLabel id="demo-simple-select-standard-label">קטגוריה</InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          label="קטגוריה"
        >
          {props.data}
        </Select>
      </FormControl>
    </div>
  );
};

export default DropDown;
